// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Button} from '../../../shared/button';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import styles from './woops_payment.module.less';

interface i_already_premium_props {
    on_click: ()=>void;
}
export const Already_premium = (props: i_already_premium_props)=>{
  const {on_click} = props;
  const {theme} = useContext(Settings_context);
  return <div className={cn(styles.root_hola2023, styles.already_premium)}>
    <p className={cn(theme.p2, theme.bold, styles.title)}>
      You are already subscribed to Hola Premium
    </p>
    <p className={cn(theme.p3)}>Continue to change your current plan</p>
    <Button on_click={on_click} caption="Continue" color="white"/>
    <p className={cn(theme.p3, styles.help)}>Need Help? Go
      to <a href="/support" target="_blank" rel="noopener noreferrer">Help
      center</a>
    </p>
  </div>;
};
